/** Отступ от верха карточки до максимальной высоты открытого дескрипшена */
export const DESCRIPTION_INDENTION = 200;

/** Коефициент скорости анимации, чтобы она зависила от высоты диекрипшена */
export const TRANSITION_TIMING_KOEF = 35;

/**  Стандартная высота дескрипшина, чтобы первая анимация начиналась снизу */
export const DEFAULT_DESCRIPTION_HEIGHT = 1000;

/**
 * Отступ по ширине, при вычитании которого из 100%
 * можно получить доступную ширину description типа short
 */
export const SHORT_DESCRIPTION_WIDTH_INDENTION = 165;

/**
 * Отступ по ширине, при вычитании которого из 100%
 * можно получить доступную ширину description типа short
 * с развернутой кнопкой товаров
 */
export const SHORT_DESCRIPTION_PRODUCT_EXPANDED_WIDTH_INDENTION = 30;

/**
 * Смещение экспандера по Y, которое нужно добавить к высоте дескрипшена,
 * чтоюы экспандер распологался по макету
 */
export const EXPANDER_DEFAULT_Y_INDENTION = 26;

/** Нижний padding раскрытого экспандера */
export const EXPANDER_BOTTOM_PADDING_EXPANDED = 52;

/** Нижний padding раскрытого экспандера при раскрытой и кнопке*/
export const EXPANDER_BOTTOM_EXPANDED_TEXT_PADDING_EXPANDED = 78;

/**
 * Смещение экспандера по Y, когда развернута кнопка товаров
 */
export const EXPANDER_PRODUCT_EXPANDED_Y_INDENTION = 90;

/** Скорость анимации кнопки товаров */
export const PRODUCT_BUTTON_TRANSITION_TIMING = 350;
